module.exports = __webpack_public_path__ + "static/img/guard_privilege_icon2.80b7515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_privilege_icon2.png
// module id = +qSL
// module chunks = 0